import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import Select from 'react-select';
import { getProgramsForUser } from '../../api/programs';
import { listAllCoachUsers } from '../../api/admin';
import './CoachHome.css';
import CoachProgramList from './CoachProgramList';
import CoachTierProgress from './CoachTierProgress';
import Loader from '../common/Loader';

const SHOW_COACH_PROGRESS = true;

function CoachHome() {
  const firstName = Cookies.get('firstName')
  const userId = Cookies.get('userId')
  const userType = Cookies.get('userType')
  const isAdmin = userType === 'admin' || userType === 'owner'

  const [searchParams, setSearchParams] = useSearchParams();
  const viewAsParam = searchParams.get('viewAs');

  const [activeTab, setActiveTab] = useState('programs')
  const [loading, setLoading] = useState(true)
  const [programs, setPrograms] = useState(null)
  const [coaches, setCoaches] = useState([])
  const [loadingCoaches, setLoadingCoaches] = useState(false)

  const selectedCoachId = viewAsParam || null;
  const isViewingOtherCoach = isAdmin && selectedCoachId && selectedCoachId !== userId;

  useEffect(() => {
    if (isAdmin) {
      setLoadingCoaches(true);
      listAllCoachUsers(false).then(res => {
        if (res?.data) {
          const options = res.data
            .sort((a, b) => `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`))
            .map(c => ({ value: c.id, label: `${c.firstName} ${c.lastName}` }));
          setCoaches(options);
        }
        setLoadingCoaches(false);
      });
    }
  }, [isAdmin]);

  useEffect(() => {
    async function fetchPrograms() {
      setLoading(true);
      try {
        const response = await getProgramsForUser(selectedCoachId);
        setPrograms(response.data);
      } catch (error) {
        console.error('Error fetching programs:', error);
      } finally {
        setLoading(false);
      }
    }
    fetchPrograms();
  }, [selectedCoachId]);

  const handleCoachChange = (option) => {
    if (!option || option.value === 'my-programs') {
      setSearchParams({});
    } else {
      setSearchParams({ viewAs: option.value });
    }
  };

  const selectedCoachOption = selectedCoachId
    ? coaches.find(c => c.value === selectedCoachId) || null
    : { value: 'my-programs', label: 'My Programs' };

  const coachOptions = [
    { value: 'my-programs', label: 'My Programs' },
    ...coaches
  ];

  const viewedCoachName = isViewingOtherCoach && selectedCoachOption?.label
    ? selectedCoachOption.label
    : null;

  const showTabs = isAdmin || SHOW_COACH_PROGRESS;

  if (loading && activeTab === 'programs') {
    return <Loader size={100} />;
  }

  return (
    <div className="coach-home">
      {viewedCoachName ? (
        <h1>Viewing: {viewedCoachName}</h1>
      ) : (
        <h1>Welcome, {firstName}!</h1>
      )}

      {isAdmin && (
        <div className="coach-selector">
          <Select
            value={selectedCoachOption}
            onChange={handleCoachChange}
            options={coachOptions}
            placeholder="Select a coach..."
            isLoading={loadingCoaches}
            className="coach-select"
          />
        </div>
      )}

      {showTabs && (
        <div className="coach-tabs">
          <button
            className={activeTab === 'programs' ? 'active' : ''}
            onClick={() => setActiveTab('programs')}
          >
            Programs
          </button>
          <button
            className={activeTab === 'progress' ? 'active' : ''}
            onClick={() => setActiveTab('progress')}
          >
            {isViewingOtherCoach ? 'Progress' : 'My Progress'}
          </button>
        </div>
      )}

      {activeTab === 'programs' ? (
        programs && <CoachProgramList programs={programs} />
      ) : (
        <CoachTierProgress isAdmin={isAdmin} selectedCoachId={selectedCoachId} />
      )}
    </div>
  );
}

export default CoachHome;
